import React, { useCallback, useEffect, useRef, useState } from "react";
import AppContext from "./AppContext";
import axios from "axios";
import Cookies from "js-cookie";
import { getUnreadMsgCount } from "../service/Notification"
import Joyride, { STATUS } from "react-joyride";
import { useLocation } from "react-router-dom";
import newMessageSound from "../assets/sound/notification-6175.mp3"
import { getLocalStorageJson } from "../utils/parseStoredJson";
const AppState = (props) => {
  const taskListFetchEpochRef = useRef(0);
  const bumpTaskListFetchEpoch = useCallback(() => {
    taskListFetchEpochRef.current += 1;
  }, []);
  const [selectedOption, setSelectedOption] = useState("");
  const [multiselectedOption, setMultiSelectedOption] = useState([]);
  const [workflowId, setWorkflowId] = useState();
  const [priority, setPriority] = useState("Priority");
  const [active, setActive] = useState("Status");
  const [isDraggable, setIsDraggable] = useState(true);
  const [taskData, setTaskData] = useState([]);
  const [taskDataHistory, settaskDataHistory] = useState([]);
  const [totalPageSize,setTotalPageSize] = useState(0)
  const [selectAll, setSelectAll] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [areaCode, setAreaCode] = useState("");
  const [accountNo, setAccountNo] = useState('');
  const [fieldAgentList, setFieldAgentList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [admincount, setAdminCount] = useState();
  const [fieldagentcount, setFieldAgentCount] = useState();
  const [officeuser, setOfficeUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalUnreadMsgCount, setTotalUnreadMsgCount] = useState(0);
  const [view, setView] = useState("graph");
  const [particularAccount, setParticularAccount] = useState([]);
  const [isEditRequest, setIsEditRequest] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [workflowName, setWorkflowName] = useState("");
  const [selectedOrgName, setSelectedOrgName] = useState("Outbox");
  const [noMoreNotifications, setNoMoreNotifications] = useState(false);
  const [fieldAgents, setFieldAgents] = useState([]);
  const [subactivity, setSubActivity] = useState([]);
  const [selectedSubactivity, setSelectedSubactivity] = useState("");
  const [getScheduleReportDetails, setgetScheduleReportDetails] = useState();
  const [userPrivileges] = useState();
  const [runTour, setRunTour] = useState(false);
  const userType = Cookies.get("userType")
  const [key, setKey] = useState(0);
  const [selectedActivityNames, setSelectedActivityNames] = useState([]);
  const [taskStatusContext, setTaskStatusContext] = useState("Active");
  const [selectedUserName, setSelectedUserName] = useState(0);
  const [openTab, setOpenTab] = useState(1);
  const [rcOrgId, setRcOrgId] = useState('')
  const [rcOrgName, setRcOrgName] = useState('')
  const [rcWorkflowName, setRcWorkflowName] = useState('')
  const [rcWorkflowId, setRcWorkflowId] = useState('')
  const [user, setUser] = useState(() => getLocalStorageJson("userDetails"));
  const [fileid, setFileId] = useState(null);
  const location = useLocation()
  const [pdfData, setPdfData] = useState([])
  const [departmentId, setDepartmentId] = useState(localStorage.getItem("departmentId"));
  const [projectId, setProjectId] = useState(localStorage.getItem("projectId"));
  const [isDcrcEnabled, setIsDcrcEnabled] = useState(false);
  const [activityId, setActivityId] = useState(localStorage.getItem("activityId"));
  const [activityLoader, setActivityLoader] = useState(false);
  const [newfield, setNewfield] = useState([])
  const currentLocationRef = useRef(location);
  const [settignModal, setSettigModal] = useState(false);

  useEffect(() => {
    currentLocationRef.current = location;
  }, [location]);

  const updateDepartmentId = (id) => {
    setDepartmentId(id);
    localStorage.setItem("departmentId", id);
  };
  const updateProjectId = (id) => {
    setProjectId(id);
    localStorage.setItem("projectId", id);
  };

  const updateActivityId = (id) => {
    setActivityId(id);
    localStorage.setItem("activityId", id);
    localStorage.setItem("selectedActivity", id);
  };


   useEffect(() => {
    setActivityLoader(true); // start loader when projectId changes
      
        const timer = setTimeout(() => {
          setActivityLoader(false); // stop loader after 100ms
        }, 100);
      
        return () => clearTimeout(timer); // cleanup
      }, [projectId]);

  useEffect(() => {
    if (location.pathname === '/task-manage') {
      let parsedFilters = {};

      try {
        const storedFilters = Cookies.get("mapListFilters");
        parsedFilters = storedFilters ? JSON.parse(storedFilters) : {};
      } catch (error) {
        console.error("Error parsing filters from cookies:", error);
        parsedFilters = {};
      }
      const selectedPriority = parsedFilters.selectedPriority || "Priority";
      const priorityValue = selectedPriority === "Priority" ? "Everything" : selectedPriority;
      setPriority(priorityValue);
      const selectedStatus = parsedFilters.selectedStatus || "Status";
      setActive(selectedStatus);
      setAreaCode(parsedFilters?.areaInput || "")
      setSelectedUserId(parsedFilters?.selectedUserId || "")
      setSubActivity(parsedFilters?.subActivity || [])

    }

  }, [location.pathname, setPriority, setActive]);

  useEffect(() => {
    const userLoggedIn = Cookies.get("FirstLogin"); // Replace this with your actual login check
  }, []);

  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [langMode, setLangMode] = useState(
    localStorage.getItem("langMode") || "en"
  );

  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("langMode", langMode);
  }, [langMode]);

  useEffect(() => {
    document.body.className = `${theme} ${langMode}`.trim();
  }, [theme, langMode]);

  const toggleTheme = (newTheme) => {
    setTheme(newTheme);
  };

  const toggleLangMode = (newLangMode) => {
    setLangMode(newLangMode);
    localStorage.setItem("langMode", newLangMode);
    document.documentElement.setAttribute("dir", newLangMode === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", newLangMode);
  };

  useEffect(() => {
    const storedLang = localStorage.getItem("langMode") || "en";
    setLangMode(storedLang);
    document.documentElement.setAttribute("dir", storedLang === "ar" ? "rtl" : "ltr");
    document.documentElement.setAttribute("lang", storedLang);
  }, []);


  const fetchNotifications = async (page) => {
    const token = Cookies.get("accessToken");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/notification/get-all?page=${page}&size=${pageSize}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (
        response.data.body &&
        Array.isArray(response.data.body.value.notificationList)
      ) {
        const newNotifications = response.data.body.value.notificationList;
        const unreadNotificationIds = newNotifications
          .filter((notification) => notification.isRead === 0)
          .map((notification) => notification.notificationId);
        if (unreadNotificationIds.length > 0) {
          await updateReadStatus(unreadNotificationIds);
        }

        setNotifications((prevNotifications) => {
          const combinedNotifications = [
            ...prevNotifications,
            ...newNotifications,
          ].filter(
            (notification, index, self) =>
              index ===
              self.findIndex((t) => t.notificationId === notification.notificationId)
          );
          return combinedNotifications.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        });

        if (newNotifications.length < pageSize) {
          setNoMoreNotifications(true);
        }
      } else {
        console.error(
          "API response does not contain expected data structure:",
          response.data
        );
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateNotificationStatus = (notificationId, isApproved) => {
    setNotifications((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.notificationId === notificationId
          ? { ...notification, isApproved }
          : notification
      )
    );
  };

  const updateNotificationReportStatus = (notificationId) => {
    setNotifications((prevNotifications) =>
      prevNotifications.map((notification) =>
        notification.notificationId === notificationId
          ? { ...notification, isAcknowledged: 1 }
          : notification
      )
    );
  };
  const updateReadStatus = async (notificationIds) => {
    const token = Cookies.get("accessToken");
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_BACKEND_API_URL}api/v1/notification/read-status`,
        { notificationIdList: notificationIds },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }

      );
      await getUnreadMsgCount()
    } catch (error) {
      console.error("Error updating notification read status:", error);
    }
  };

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false); // Stop running the tour
    }
  };
  const menu = [
    {
      target: ".org",
      content: "Select organization form here!",
    },
    {
      target: ".activity",
      content: "Select Activity from here!",
    },
    {
      target: ".notification",
      content: "Click here to see notifications!",
    },
    {
      target: ".seting",
      content: "Click here to go settings!",
    },
  ];
  const dashboard = [

    {
      target: ".activitydashboard",
      content: "Click here to create custom dashboard!",
    },
    {
      target: ".chooseworkflow",
      content: "Choose the workflow to see the charts!",
    },
    {
      target: ".importpdf",
      content: "From here u can download the PDF!",
    },
  ];
  const activityDash = [
    {
      target: ".selectdashboardname",
      content: "Click here to select Dashboard name!",
    },
    {
      target: ".createdashboard",
      content: "Click here to create dashboards!",
    },
  ];
  const workflow = [
    {
      target: ".createworkflows",
      content: "Click here for creating dynamic workflow!",
    },
    {
      target: ".cloneworkflow",
      content: "Click here for clone the dynamic workflow!",
    },
    {
      target: ".editworkflow",
      content: "Click here for edit the existing dynamic workflow!",
    },
    {
      target: ".deleteworkflow",
      content: "Click here for delete the dynamic workflow!",
    },
  ];
  const workflowmaker = [
    {
      target: ".fields",
      content: "Drag the field from here!",
    },
    {
      target: ".droparea",
      content: "Drop the  fields in droppable area!",
    },
    {
      target: ".mandtory",
      content: "Click this to make field mandatory!",
    },
    {
      target: ".excel",
      content: "Click this to add excel name to this field!",
    },
    {
      target: ".pdf",
      content: "Click this to add PDF name to this field!",
    },
  ];

  const tasktollbar = [
    {
      target: ".download",
      content: "Click here to download the uploaded task sheet!",
    },
    {
      target: ".deleteAll",
      content: "Click here to delete the uploaded tasklist!",
    },
    {
      target: ".createTask",
      content: "Click here to create task manually!",
    },
    {
      target: ".gocsv",
      content: "Click here to upload the task list!",
    },
  ];
  const maptoolbar = [
    {
      target: ".multiselect",
      content: "Click here to drow and select the tasks!",
    },
    {
      target: ".smartAssign",
      content: "Click here to assign the assignment rules!",
    },
    {
      target: ".fieldagent",
      content: "Click here to see field agent list!",
    },
    {
      target: ".createTask",
      content: "Click here to create task manually!",
    },
    {
      target: ".gocsvs",
      content: "Click here to upload the task list!",
    },
  ];
  const workLogtoolbar = [
    {
      target: ".shecduleemail",
      content: "Click here to Schedule a email !",
    },
    {
      target: ".exportreport",
      content: "Click here to download excel report!",
    },
    {
      target: ".exportpdf",
      content: "Click here to download PDF !",
    },
  ];

  const toggle = [
    {
      target: ".menus",
      content: "Click here to view menus",
    },
  ];
  const enableSound = () => {
    audio.play().catch((err) => console.error('User interaction required:', err));
  };
  const audio = new Audio(newMessageSound);

  useEffect(() => {
    navigator.serviceWorker.addEventListener('message', async (event) => {
    console.log(event)
      if (event.data && event.data.isFirebaseMessaging === true) {
        console.log('New push notification received');

        const data = await getUnreadMsgCount();
        if (data?.header?.code === 600 && data.body?.value?.unreadMsgCount !== undefined) {
          const unreadCount = data.body.value.unreadMsgCount;
          setTotalUnreadMsgCount(unreadCount);
          console.log('Unread message count updated:', unreadCount);
          if (unreadCount > 0) {
            enableSound();
            const audio = new Audio('/notification.mp3');
            audio.play().catch((err) => console.error('Error playing sound:', err));
          }
        }
      }
    });
  }, []);

  
  return (
    <AppContext.Provider
      value={{
        fileid, setFileId,
        key, setKey,
        toggle,
        activityDash,
        workLogtoolbar,
        maptoolbar,
        tasktollbar,
        handleJoyrideCallback,
        workflowmaker,
        workflow,
        dashboard,
        menu,
        getScheduleReportDetails,
        setgetScheduleReportDetails,
        selectedSubactivity,
        setSelectedSubactivity,
        setFieldAgents,
        fieldAgents,
        selectAll,
        setSelectAll,
        selectedOption,
        setSelectedOption,
        workflowId,
        setWorkflowId,
        setPriority,
        priority,
        active,
        setActive,
        areaCode,
        setAreaCode,
        setAccountNo,
        accountNo,
        setIsDraggable,
        isDraggable,
        setTaskData,
        taskData,
        taskListFetchEpochRef,
        bumpTaskListFetchEpoch,
        totalPageSize,
        setTotalPageSize,
        settaskDataHistory,
        setFieldAgentList,
        fieldAgentList,
        setSelectedUserId,
        selectedUserId,
        taskDataHistory,
        profilePic,
        setProfilePic,
        setNotifications,
        notifications,
        multiselectedOption,
        setMultiSelectedOption,
        user,
        setUser,
        theme,
        toggleTheme,
        fetchNotifications,
        isLoading,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        updateNotificationStatus,
        updateNotificationReportStatus,
        totalUnreadMsgCount,
        setTotalUnreadMsgCount,
        setView,
        view,
        admincount,
        setAdminCount,
        fieldagentcount,
        setFieldAgentCount,
        officeuser,
        setOfficeUser,
        setParticularAccount,
        particularAccount,
        setIsEditRequest,
        isEditRequest,
        setSelectedOrgId,
        selectedOrgId,
        workflowName,
        setWorkflowName,
        selectedOrgName,
        setSelectedOrgName,
        noMoreNotifications,
        setNoMoreNotifications,
        subactivity,
        setSubActivity,
        // resetDropdown,
        langMode,
        setLangMode,
        toggleLangMode,
        runTour,
        setRunTour,
        userPrivileges,
        userType,
        selectedActivityNames, setSelectedActivityNames, setIsLoading,
        taskStatusContext,
        setTaskStatusContext,
        selectedUserName, setSelectedUserName,
        openTab, setOpenTab, totalUnreadMsgCount, setTotalUnreadMsgCount,
        rcOrgName, setRcOrgName,
        rcOrgId, setRcOrgId,
        rcWorkflowId, setRcWorkflowId,
        rcWorkflowName, setRcWorkflowName, pdfData, setPdfData,
        updateDepartmentId,departmentId,
        updateProjectId,projectId,
        isDcrcEnabled,setIsDcrcEnabled,
        currentLocationRef,
        updateActivityId,activityId, activityLoader,newfield, setNewfield
        ,settignModal, setSettigModal
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default AppState;
